import Store from "../../../Store/Store";

class UnitTypeContainer {
  public pickLabelFromId(id) {
    const unitType = Store.getConfigurator().getState().globalTypes?.UnitType;
    for(const key in unitType) {
      if (unitType[key].id === id) {
        return unitType[key].label
      }
    }
  }

  public pickIdFromLabel(label) {
    const unitType = Store.getConfigurator().getState().globalTypes?.UnitType;
    for(const key in unitType) {
      if (unitType[key].label?.toLowerCase() === label?.toLowerCase()) {
        return unitType[key].id
      }
    }
  }
}

export default new UnitTypeContainer();
